import { Message } from './message';
import { HttpMethods, RequestInterface } from '../../interfaces/components/http-client/request.interface';

export class Request extends Message implements RequestInterface {
  private body: BodyInit | null;
  private method: HttpMethods;

  public constructor (method: HttpMethods, uri: URL | string, headers?: RequestInit['headers'], body?: BodyInit) {
    super(uri, headers);
    this.method = method;
    this.body = body ?? null;
  }

  public getMethod (): HttpMethods {
    return this.method;
  }

  public withMethod (method: HttpMethods): RequestInterface {
    this.method = method;
    return this;
  }

  public getBody (): BodyInit | null {
    return this.body;
  }

  public withBody (body: BodyInit | null): RequestInterface {
    this.body = body;
    return this;
  }
}
